import { DeviceTypeEnum } from 'shared/hooks/use-metadata-from-server'
import { defaultBreakpoints } from '../constants/default-breakpoints'
import { serverDeviceBreakpointOverrides } from '../constants/server-device-breakpoint-overrides'
import { BreakpointsStateInterface } from '../types/breakpoints-state'

export const getBreakpointsByServerDeviceType = (
  serverDeviceType: DeviceTypeEnum = DeviceTypeEnum.Unknown,
): BreakpointsStateInterface => ({
  ...defaultBreakpoints,
  ...serverDeviceBreakpointOverrides[serverDeviceType],
})
